import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useWebsiteSettings } from '../../context/WebsiteSettingsContext';
import '../../styles/AdminShared.css';
import './WebsiteSettings.css';

// API Base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

interface WebsiteSettingsData {
  id?: number;
  site_name: string;
  site_description: string;
  logo?: string | File | null;
  logo_url?: string | null;
  background_image?: string | File | null;
  background_image_url?: string | null;
  favicon?: string | File | null;
  favicon_url?: string | null;
  support_phone?: string;
  whatsapp_number?: string;
  support_email?: string;
  facebook_url?: string;
  instagram_url?: string;
  twitter_url?: string;
  tiktok_url?: string;
}

// Icons Components
const Icons = {
  Settings: () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>,
  Save: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>,
  Globe: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>,
  Mail: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>,
  Phone: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>,
  MessageCircle: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>,
  Image: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>,
  UploadCloud: () => <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.5-3.2-3.2-5.6-6.4-5.6-3.7 0-6.7 2.8-6.9 6.5-2.7.3-4.8 2.6-4.6 5.4.1 2.3 2 4.2 4.3 4.2h12.5c2.5 0 4.6-1.9 4.8-4.4z"></path></svg>,
  Upload: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>,
  Trash: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>,
  Edit: () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>,
  Facebook: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>,
  Instagram: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>,
  Twitter: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path></svg>,
  Music: () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle></svg>,
  Layout: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
};

const WebsiteSettings: React.FC = () => {
  const { refreshSettings } = useWebsiteSettings();
  const [settings, setSettings] = useState<WebsiteSettingsData>({
    site_name: '',
    site_description: '',
    logo: null,
    logo_url: null,
    background_image: null,
    background_image_url: null,
    favicon: null,
    favicon_url: null,
    support_phone: '',
    whatsapp_number: '',
    support_email: '',
    facebook_url: '',
    instagram_url: '',
    twitter_url: '',
    tiktok_url: '',
  });
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [previewFavicon, setPreviewFavicon] = useState<string | null>(null);
  const [previewLogo, setPreviewLogo] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [dragActive, setDragActive] = useState<'background' | 'favicon' | 'logo' | null>(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/settings/website/`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });

      if (response.ok) {
        const data = await response.json();
        setSettings(data);
        if (data.background_image_url) setPreviewImage(data.background_image_url);
        if (data.favicon_url) setPreviewFavicon(data.favicon_url);
        if (data.logo_url) setPreviewLogo(data.logo_url);
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  const processImage = (file: File, type: 'background' | 'favicon' | 'logo') => {
    if (!file.type.startsWith('image/')) {
      Swal.fire({ icon: 'error', title: 'Invalid File', text: 'Please select an image file' });
      return;
    }
    const maxSize = type === 'background' ? 5 * 1024 * 1024 : 1 * 1024 * 1024;
    if (file.size > maxSize) {
      Swal.fire({ icon: 'error', title: 'File Too Large', text: `Max size is ${type === 'background' ? '5MB' : '1MB'}` });
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      if (type === 'background') { setPreviewImage(reader.result as string); setSettings(prev => ({ ...prev, background_image: file as any })); }
      else if (type === 'favicon') { setPreviewFavicon(reader.result as string); setSettings(prev => ({ ...prev, favicon: file as any })); }
      else if (type === 'logo') { setPreviewLogo(reader.result as string); setSettings(prev => ({ ...prev, logo: file as any })); }
    };
    reader.readAsDataURL(file);
  };

  const handleImageSelect = (e: React.ChangeEvent<HTMLInputElement>, type: 'background' | 'favicon' | 'logo') => {
    const file = e.target.files?.[0];
    if (file) processImage(file, type);
  };

  const handleDrag = (e: React.DragEvent, type: 'background' | 'favicon' | 'logo') => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(type);
    } else if (e.type === 'dragleave') {
      setDragActive(null);
    }
  };

  const handleDrop = (e: React.DragEvent, type: 'background' | 'favicon' | 'logo') => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(null);
    
    const file = e.dataTransfer?.files?.[0];
    if (file) processImage(file, type);
  };

  // Helper component for Image Upload Zones with Drag & Drop
  const ImageUploadZone = ({ 
    type, 
    preview, 
    onSelect, 
    onRemove,
    onDrag,
    onDrop,
    isDragging
  }: { 
    type: 'logo' | 'favicon' | 'background', 
    preview: string | null, 
    onSelect: (e: React.ChangeEvent<HTMLInputElement>) => void, 
    onRemove: () => void,
    onDrag: (e: React.DragEvent) => void,
    onDrop: (e: React.DragEvent) => void,
    isDragging: boolean
  }) => {
    const isBackground = type === 'background';
    const label = type === 'logo' ? 'Website Logo' : type === 'favicon' ? 'Favicon' : 'Login Background';
    const dimensions = type === 'logo' ? '150x50px' : type === 'favicon' ? '32x32px' : '1920x1080px';
    const acceptedFormat = 'PNG, JPG, WEBP';

    return (
      <div className={`upload-zone-container ${isBackground ? 'full-width' : ''}`}>
        {!isBackground && <h4 className="zone-label">{label}</h4>}
        
        <div 
          className={`upload-zone ${isBackground ? 'background-zone' : ''} ${preview ? 'has-preview' : ''} ${isDragging ? 'drag-active' : ''}`}
          onDragEnter={(e) => onDrag(e)}
          onDragOver={(e) => onDrag(e)}
          onDragLeave={(e) => onDrag(e)}
          onDrop={(e) => onDrop(e)}
        >
          <input 
            type="file" 
            id={`file-${type}`} 
            onChange={onSelect} 
            accept="image/*" 
            className="hidden-input" 
          />
          
          {preview ? (
            <div className="preview-wrapper">
              <img src={preview} alt={`${type} preview`} className={`preview-img ${type}-preview`} />
              <div className="preview-overlay">
                <label htmlFor={`file-${type}`} className="btn-icon-action edit" title="Change Image">
                  <Icons.Edit />
                </label>
                <button type="button" className="btn-icon-action remove" onClick={onRemove} title="Remove Image">
                  <Icons.Trash />
                </button>
              </div>
            </div>
          ) : (
            <label htmlFor={`file-${type}`} className="empty-zone-label">
              <div className="upload-icon-circle">
                <Icons.UploadCloud />
              </div>
              <span className="upload-text">Drag & drop or click to upload</span>
              <span className="upload-hint">{dimensions} • {acceptedFormat}</span>
            </label>
          )}
        </div>
      </div>
    );
  };

  const handleRemoveImage = async (type: 'background' | 'favicon' | 'logo') => {
      const result = await Swal.fire({
        title: 'Remove Image?',
        text: `Are you sure you want to remove the ${type}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ef4444',
        cancelButtonColor: '#3b82f6',
        confirmButtonText: 'Yes, remove it!',
      });
  
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const token = localStorage.getItem('token');
          const endpoint = type === 'background' ? 'delete_background' : type === 'favicon' ? 'delete_favicon' : 'delete_logo';
          const response = await fetch(`${API_BASE_URL}/settings/website/${endpoint}/`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` },
          });
  
          if (response.ok) {
            if (type === 'background') { setPreviewImage(null); setSettings(prev => ({ ...prev, background_image: null, background_image_url: null })); }
            else if (type === 'favicon') { setPreviewFavicon(null); setSettings(prev => ({ ...prev, favicon: null, favicon_url: null })); }
            else if (type === 'logo') { setPreviewLogo(null); setSettings(prev => ({ ...prev, logo: null, logo_url: null })); }
            Swal.fire({ icon: 'success', title: 'Removed', timer: 1500, showConfirmButton: false });
          } else throw new Error('Failed to remove image');
        } catch (error) {
          Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to remove image' });
        } finally {
          setLoading(false);
        }
      }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      
      formData.append('site_name', settings.site_name);
      formData.append('site_description', settings.site_description);
      formData.append('support_phone', settings.support_phone || '');
      formData.append('whatsapp_number', settings.whatsapp_number || '');
      formData.append('support_email', settings.support_email || '');
      formData.append('facebook_url', settings.facebook_url || '');
      formData.append('instagram_url', settings.instagram_url || '');
      formData.append('twitter_url', settings.twitter_url || '');
      formData.append('tiktok_url', settings.tiktok_url || '');

      if (settings.background_image instanceof File) formData.append('background_image', settings.background_image);
      if (settings.favicon instanceof File) formData.append('favicon', settings.favicon);
      if (settings.logo instanceof File) formData.append('logo', settings.logo);

      const response = await fetch(`${API_BASE_URL}/settings/website/1/`, {
        method: 'PUT',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setSettings(data);
        if (data.background_image_url) setPreviewImage(data.background_image_url);
        if (data.favicon_url) setPreviewFavicon(data.favicon_url);
        if (data.logo_url) setPreviewLogo(data.logo_url);
        await refreshSettings();
        Swal.fire({ icon: 'success', title: 'Saved!', text: 'Settings updated successfully', timer: 1500, showConfirmButton: false });
      } else throw new Error('Failed');
    } catch (error) {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to update settings' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="website-settings-container">
      <form onSubmit={handleSubmit}>
        {/* Header Section */}
        <div className="settings-page-header">
          <div className="header-titles">
            <h1><Icons.Settings /> Website Settings</h1>
            <p>Manage your website's core configuration and appearance</p>
          </div>
          <button type="submit" className="btn-save" disabled={loading}>
            <Icons.Save /> {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>

        {/* Settings Grid */}
        <div className="settings-grid">
          {/* General Information Card */}
          <div className="settings-card">
            <div className="card-header">
              <div className="card-icon icon-blue"><Icons.Globe /></div>
              <h3>General Information</h3>
            </div>
            <div className="card-content">
              <div className="form-group">
                <label>Site Name</label>
                <div className="input-wrapper">
                  <div className="input-icon"><Icons.Layout /></div>
                  <input
                    type="text"
                    name="site_name"
                    value={settings.site_name}
                    onChange={handleInputChange}
                    placeholder="My Awesome Store"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  name="site_description"
                  value={settings.site_description}
                  onChange={handleInputChange}
                  placeholder="Tell customers about your store..."
                  rows={3}
                  className="form-textarea"
                />
              </div>

              <div className="form-group">
                <label>Support Email</label>
                <div className="input-wrapper">
                  <div className="input-icon"><Icons.Mail /></div>
                  <input
                    type="email"
                    name="support_email"
                    value={settings.support_email || ''}
                    onChange={handleInputChange}
                    placeholder="support@example.com"
                    className="form-input"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Support Phone</label>
                  <div className="input-wrapper">
                    <div className="input-icon"><Icons.Phone /></div>
                    <input
                      type="text"
                      name="support_phone"
                      value={settings.support_phone || ''}
                      onChange={handleInputChange}
                      placeholder="+880 1XXX XXXXXX"
                      className="form-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>WhatsApp</label>
                  <div className="input-wrapper">
                    <div className="input-icon"><Icons.MessageCircle /></div>
                    <input
                      type="text"
                      name="whatsapp_number"
                      value={settings.whatsapp_number || ''}
                      onChange={handleInputChange}
                      placeholder="8801XXXXXXXXX"
                      className="form-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Social Media Card */}
          <div className="settings-card">
            <div className="card-header">
              <div className="card-icon icon-purple"><Icons.MessageCircle /></div>
              <h3>Social Media Links</h3>
            </div>
            <div className="card-content">
              <div className="social-grid">
                <div className="form-group">
                  <label>Facebook</label>
                  <div className="input-wrapper">
                    <div className="input-icon social-fb"><Icons.Facebook /></div>
                    <input
                      type="url"
                      name="facebook_url"
                      value={settings.facebook_url || ''}
                      onChange={handleInputChange}
                      placeholder="facebook.com/page"
                      className="form-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Instagram</label>
                  <div className="input-wrapper">
                    <div className="input-icon social-insta"><Icons.Instagram /></div>
                    <input
                      type="url"
                      name="instagram_url"
                      value={settings.instagram_url || ''}
                      onChange={handleInputChange}
                      placeholder="instagram.com/profile"
                      className="form-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>Twitter / X</label>
                  <div className="input-wrapper">
                    <div className="input-icon social-tw"><Icons.Twitter /></div>
                    <input
                      type="url"
                      name="twitter_url"
                      value={settings.twitter_url || ''}
                      onChange={handleInputChange}
                      placeholder="twitter.com/profile"
                      className="form-input"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label>TikTok</label>
                  <div className="input-wrapper">
                    <div className="input-icon social-tt"><Icons.Music /></div>
                    <input
                      type="url"
                      name="tiktok_url"
                      value={settings.tiktok_url || ''}
                      onChange={handleInputChange}
                      placeholder="tiktok.com/@profile"
                      className="form-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Branding Row */}
          <div className="settings-row-split">
            {/* Logo & Favicon Card */}
            <div className="settings-card">
              <div className="card-header">
                <div className="card-icon icon-orange"><Icons.Image /></div>
                <h3>Branding Assets</h3>
              </div>
              <div className="card-content">
                <div className="branding-grid">
                  <ImageUploadZone 
                    type="logo" 
                    preview={previewLogo} 
                    onSelect={(e) => handleImageSelect(e, 'logo')} 
                    onRemove={() => handleRemoveImage('logo')}
                    onDrag={(e) => handleDrag(e, 'logo')}
                    onDrop={(e) => handleDrop(e, 'logo')}
                    isDragging={dragActive === 'logo'}
                  />
                  <ImageUploadZone 
                    type="favicon" 
                    preview={previewFavicon} 
                    onSelect={(e) => handleImageSelect(e, 'favicon')} 
                    onRemove={() => handleRemoveImage('favicon')}
                    onDrag={(e) => handleDrag(e, 'favicon')}
                    onDrop={(e) => handleDrop(e, 'favicon')}
                    isDragging={dragActive === 'favicon'}
                  />
                </div>
              </div>
            </div>

            {/* Background Image Card */}
            <div className="settings-card">
              <div className="card-header">
                <div className="card-icon icon-green"><Icons.Image /></div>
                <h3>Login Background</h3>
              </div>
              <div className="card-content">
                <ImageUploadZone 
                  type="background" 
                  preview={previewImage} 
                  onSelect={(e) => handleImageSelect(e, 'background')} 
                  onRemove={() => handleRemoveImage('background')}
                  onDrag={(e) => handleDrag(e, 'background')}
                  onDrop={(e) => handleDrop(e, 'background')}
                  isDragging={dragActive === 'background'}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default WebsiteSettings;
